export var SlideInterface;
(function (SlideInterface) {
    // 页内应用字体的范围
    var EFontFamilyApplyPart;
    (function (EFontFamilyApplyPart) {
        // 标题+正文
        EFontFamilyApplyPart["ALL"] = "all";
        // 标题
        EFontFamilyApplyPart["TITLE"] = "title";
        // 正文
        EFontFamilyApplyPart["CONTENT"] = "content";
    })(EFontFamilyApplyPart = SlideInterface.EFontFamilyApplyPart || (SlideInterface.EFontFamilyApplyPart = {}));
    // 应用的页
    var EFontFamilyApplySlide;
    (function (EFontFamilyApplySlide) {
        // 全部页
        EFontFamilyApplySlide["ALL"] = "all";
        // 当前页
        EFontFamilyApplySlide["CURRENT"] = "current";
    })(EFontFamilyApplySlide = SlideInterface.EFontFamilyApplySlide || (SlideInterface.EFontFamilyApplySlide = {}));
    /** ------ slide 模版审核专用数据结构 start ------ */
    // 审核结果分类
    var CheckResultItemRootIds;
    (function (CheckResultItemRootIds) {
        CheckResultItemRootIds["TOP_PRIORITY"] = "top-priority";
        CheckResultItemRootIds["PAGE_META"] = "page-meta";
        CheckResultItemRootIds["TITLE"] = "title";
        CheckResultItemRootIds["PARAGRAPH"] = "paragraph";
        CheckResultItemRootIds["TEXT"] = "text";
        CheckResultItemRootIds["ELEMENT"] = "element";
        CheckResultItemRootIds["PIC"] = "pic";
        CheckResultItemRootIds["COPYRIGHT"] = "copyright";
        CheckResultItemRootIds["SLIDE_MASTER_LAYOUT"] = "slide-master-layout";
        CheckResultItemRootIds["SLIDE_AI"] = "slide-ai";
    })(CheckResultItemRootIds = SlideInterface.CheckResultItemRootIds || (SlideInterface.CheckResultItemRootIds = {}));
    /** ------ 模版审核专用数据结构 end ------ */
})(SlideInterface || (SlideInterface = {}));
//# sourceMappingURL=slide.js.map